const configurationData = {
  supported_resolutions: ['1', '2', '3', '5', '10', '15', '30', '60', '120', '180', '240', '1D']
};

export const onReady = (callback) => {
  // console.log('[onReady]: Method call');
  setTimeout(() => callback(configurationData));
};
